import Doclist from "./doclist";

export default Doclist